import React, { useState, useEffect } from 'react';
import PolicyDisplayCard from './PolicyDisplayCard';
import { va } from "../../../../utils/commonUtils";


type myBenefitsPageProps = {
    estimationResponse: any;
};



export const extractEstimator = (estimationResponse: any) => {
    const illustration = estimationResponse && estimationResponse.illustration ? estimationResponse.illustration : {totalincome: 0};
    const common = estimationResponse && estimationResponse.common;
    const illustrationTables = (illustration && illustration.data && illustration.data.table) || [];
    const targetAgeDB = 95;
    const table0PremiumPaid = illustrationTables && va(illustrationTables) && illustrationTables[0];
    const targetAgeCashSurrender = estimationResponse && estimationResponse.common && estimationResponse.common.incomeagefrom - 1;
    const foundCashSurrender = illustrationTables.find((r: { age: number; }) => r.age === targetAgeCashSurrender);
    const foundDeathBenefit = illustrationTables.find((r: { age: number; }) => r.age === targetAgeDB);
    const premiumPaid = table0PremiumPaid && table0PremiumPaid.premiumpaid;
    const contributionAmount = common && common.contributionamount;
    return {
        contributionAmount: contributionAmount || 0,
        illustrationTables: illustrationTables,
        common: common,
        cashSurrender: foundCashSurrender ? foundCashSurrender.cashsurrender : 0,
        deathBenefit: foundDeathBenefit? foundDeathBenefit.deathbenefit : 0,
        bankContribution: premiumPaid - contributionAmount,
        premiumPaid: table0PremiumPaid ? table0PremiumPaid.premiumpaid : 0,
    }
}

function PolicyMainCard(props:myBenefitsPageProps) {
    const { estimationResponse } = props;
    console.log("estimationResponse", estimationResponse);

    let totalPaid = 0
    let {
        contributionAmount,
        bankContribution,
    } = extractEstimator(estimationResponse);
    if((contributionAmount) || (bankContribution)){
        contributionAmount = contributionAmount * 5
        bankContribution = bankContribution * 5
        totalPaid = bankContribution + contributionAmount;
    }

    return (
            <div className="App">
                <PolicyDisplayCard
                        title="Total Paid to Policy Over 10 Years"
                        totalAmount={totalPaid}
                        userAmount={contributionAmount}
                        bankAmount={bankContribution}
                />
            </div>
    );
}

export default PolicyMainCard;